import { Center, Flex, Loader, Text } from "@mantine/core";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AppRoutes } from "@/constants";

const ClientRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const businessId = params.get("businessId");

    // Remove businessId from params for the redirect
    if (businessId) {
      params.delete("businessId");
      const paramString = params.toString();
      const redirectPath = `/${businessId}/register${paramString ? `?${paramString}` : ""}`;
      navigate(redirectPath, { replace: true });
    } else {
      // Preserve all query parameters (like referrerId) when redirecting
      const paramString = params.toString();
      const redirectPath = `${AppRoutes.gettingStarted}${paramString ? `?${paramString}` : ""}`;
      navigate(redirectPath, { replace: true });
    }
  }, [location.search, navigate]);

  // Optionally, render nothing or a loading indicator
  return (
    <Center h="100vh">
      <Flex gap="md" align="center">
        <Text>Redirecting...</Text>
        <Loader />
      </Flex>
    </Center>
  );
};

export default ClientRedirect;
